import React from "react";
import { AccountBalance, Payment } from "@mui/icons-material";
import { NavLink } from "react-router-dom";

// Универсальная обёртка под v6 с поддержкой end (аналог exact)
const NavLinkV6 = ({
  children,
  to,
  className,
  activeclassName,
  keyName = "keyForNavLink",
  end, // <- если нужен "точный" матч (как exact в v5), передай end
  ...rest
}) => {
  const cls = (isActive) =>
    [className, isActive && activeclassName].filter(Boolean).join(" ");

  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => cls(isActive)}
      key={keyName}
      {...rest}
    >
      {children}
    </NavLink>
  );
};

// Внешняя ссылка
const A = ({
  children,
  to,
  className,
  keyName = "keyForA",
  target = "_blank",
  rel = "noopener noreferrer",
  ...rest
}) => (
  <a
    href={to}
    className={className}
    key={keyName}
    target={target}
    rel={rel}
    {...rest}
  >
    {children}
  </a>
);

const OrderCardPageContainer = React.lazy(() =>
  import("./../Components/OrderCardPage/OrderCardPageContainer")
);
const CardMoreContainer = React.lazy(() =>
  import("./../Components/CardsPage/CardMore/CardMoreContainer")
);
const CreditPageContainer = React.lazy(() =>
  import("./../Components/CreditPage/CreditPageContainer")
);
const CardsPageContainer = React.lazy(() =>
  import("./../Components/CardsPage/CardsPageContainer")
);
const ApplicantPageContainer = React.lazy(() =>
  import("./../Components/ApplicantPage/ApplicantPageContainer")
);
const ModifyApplicantContainer = React.lazy(() =>
  import(
    "./../Components/ApplicantPage/ModifyApplicant/ModifyApplicantContainer"
  )
);
const PaymentResultContainer = React.lazy(() =>
  import("./../Components/ApplicantPage/PaymentResult/PaymentResultContainer")
);
const BranchInfoContainer = React.lazy(() =>
  import("./../Components/common/BranchInfo/BranchInfoContainer")
);

export const RoutesNames = {
  ORDERCARD: "/cards/orderCard",
  CARDMORE: "/cards/cardMore",
  CARDS: "/cards",
  CREDITS: "/credits",
  SERVICES: "/services",
  APPLICANT: "/applicant",
  PAYMENTRESULT: "/paymentresult",
  MODIFYAPPLICANT: "/applicant/modify",
  BRANCH: "/applicant/branchInfo",
};

export const links = {
  loan: "https://loan.tnbk.tm",
  main: "https://www.tnbk.tm",
  tarif: "https://www.tnbk.tm/tm/rko.html",
  privacyPolicy_tm: "https://www.tnbk.tm/Privacy_Policy_tm.pdf",
  privacyPolicy_ru: "https://www.tnbk.tm/Privacy_Policy_ru.pdf",
};

export const navRoutes = [
  {
    path: RoutesNames.CARDS,
    icon: Payment,
    title: "card-application",
    component: NavLinkV6, // можно передать end: true, если нужно точное совпадение
    action: function () {},
  },
  {
    path: links.loan,
    icon: AccountBalance,
    title: "credit-application",
    component: A,
    action: function () {},
  },
];

// В v6 exact больше не существует — убираем его из описаний
export const publicRoutes = [
  { path: RoutesNames.ORDERCARD, component: OrderCardPageContainer },
  { path: RoutesNames.CARDMORE, component: CardMoreContainer },
  { path: RoutesNames.CARDS, component: CardsPageContainer },
  { path: RoutesNames.CREDITS, component: CreditPageContainer },
  { path: RoutesNames.APPLICANT, component: ApplicantPageContainer },
  { path: RoutesNames.MODIFYAPPLICANT, component: ModifyApplicantContainer },
  { path: RoutesNames.PAYMENTRESULT, component: PaymentResultContainer },
  { path: RoutesNames.BRANCH, component: BranchInfoContainer },
];
